export const GATEWAY_STATES = [
  'online',
  'offline',
  'starting',
  'stopping',
  'pending',
] as const;

export type GatewayState = (typeof GATEWAY_STATES)[number];

export type Gateway = {
  readonly id: string;
  name: string;
  status: GatewayState;
  application_id: string;
  configuration_id: string | null;
  ip_ext: string | null;
  ip_local: string | null;
  mac_address: string | null;
  model: string | null;
  version: string | null;
  is_managed: boolean;
  /** ISO date string */
  stops_automatically_at: string | null;
  max_running_deployments: number;
  max_deployments_per_process: number;
  onvif_request_timeout_secs: number;
  tags: string[];
  readonly created_at: string;
  readonly updated_at: string;
};
